import { iHttp, simulatorBus } from '@/core';
import LoadingBar from '@/components/loading-bar/index';
import { message as $Message } from 'ant-design-vue';

export default class Axios {

	constructor() {
		// 考虑到在new http的时候uris还未能获取到
		// 原因是report应用在各个不同域名站点，所以顾及到cookie不能同步
		// 所以在他们的站点中将report需要的信息尽可能通过postMessage传过来，然后report存储到cookie和sessionStorage
		this.request = new iHttp({
			// baseURL: "https://gateway-dev-k8s.smarteventcloud.cn",
			alert: function(message) {
				$Message.error(message);
			},
			block: LoadingBar.start(),
			unblock: LoadingBar.finish(),
			handle401: function() {
				simulatorBus.openiaccount();
			}
		}).api;
	}

	// 获取报表搜索项
	QueryConditions(params) {
		return this.request.post(`/api/services/datav/FnReportService/Report/QueryConditions`, params);
	}
	// 获取inputModel参数
	GetReportSet(params) {
		return this.request.post(`/api/services/report/FnReportService/GetReportSet`, params);
	}
	// 查询报表列表
	ReportQuery(params) {
		return this.request.post(`/api/services/datav/FnReportService/Report/Query`, params);
	}
	// 查看导出日志
	PagingExportLogs(params) {
		return this.request.post(`/api/services/datav/FnReportService/Report/PagingExportLogs`, params);
	}
	// 导出
	ReportExport(params) {
		return this.request.post(`/api/services/datav/FnReportService/Report/Export`, params);
	}
	// 字典查询
	FndictionaryQuery(params) {
		return this.request.post(`/foundation/dict/api/fndictionary/query`, params);
	}
	// 查询报表列表 TODO
	QueryReport(params) {
		return this.request.post(`api/pdata/queryReport`, params);
		// return this.request.post(`api/queryReport`, params);
	}
	// 下载报表excel TODO
	DownloadReport(params) {
        return this.request.post(`api/pdata/downloadReport`, params);
        // return this.request.post(`api/downloadReport`, params);
	}
	// TPM查询
	getTpmSetting(params) {
		return this.request.post(`/api/tpm/cfg/getsettings`, params);
	}

}
